import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./compound_mod_group_type.js";
//#region src/compound_mod_group_type_helper.ts
var compound_mod_group_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(type) {
	switch (type) {
		case "merge-remove-regular-extra-mods": return "Merge Remove/Regular/Extra Mods";
	}
}
//#endregion
export { compound_mod_group_type_helper_exports, name };

//# sourceMappingURL=compound_mod_group_type_helper.js.map